import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      style={{ zIndex: 9999 }}
      toastOptions={{
        style: {
          background: 'hsl(0 0% 14.9%)',
          color: 'hsl(0 0% 98%)',
          border: '1px solid hsl(0 0% 14.9%)',
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-gray-800 group-[.toaster]:text-white group-[.toaster]:border-gray-700 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-300",
          actionButton:
            "group-[.toast]:bg-amber-600 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-gray-700 group-[.toast]:text-gray-200",
          success: "group-[.toast]:bg-green-800 group-[.toast]:border-green-700",
          error: "group-[.toast]:bg-red-800 group-[.toast]:border-red-700",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
